module.exports = __webpack_public_path__ + "media/images/page/estate_property_owners/img_03-960672edbb0d2e66a74c1307da817b00.jpg";